// The nav's single source of truth (#257) — Nav.tsx and Shell.tsx both
// import this so the tab list/order is defined exactly once. Plain
// `useState` tab switching, no router (precedent: load-generator-ui's
// App.tsx) — this app has no deep-linkable per-screen state yet, and
// nothing here needs browser history/back-button support.
//
// #258-261 filled in Orders/Stock/Catalog/Users; #262 (ADR 0064) adds Run +
// Failure config, absorbed from the retired load-generator-ui.

export type ScreenId = "dashboard" | "orders" | "stock" | "catalog" | "users" | "run" | "failureConfig";

export interface ScreenDef {
  id: ScreenId;
  label: string;
}

export const SCREENS: ScreenDef[] = [
  { id: "dashboard", label: "Dashboard" },
  { id: "orders", label: "Orders" },
  { id: "stock", label: "Stock" },
  { id: "catalog", label: "Catalog" },
  { id: "users", label: "Users" },
  { id: "run", label: "Run" },
  { id: "failureConfig", label: "Failure config" },
];
